// extracted by mini-css-extract-plugin
export default {"tagsContainer":"TagSelector-module__tagsContainer___3y-n7"};